import { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Helmet } from "react-helmet";
import "swiper/css";
import "swiper/css/effect-fade";
import { Autoplay, EffectFade } from "swiper/modules";
import { Circles } from 'react-loader-spinner';
import slidesData from '../Lib/slidesData';
import { Link } from "react-router-dom";
import About from './About';
import Choose from './Choose';
import Testimonials from './Testimonials';
import Contact from './Contact';



const Home = () => {
  const [loading, setLoading] = useState(true);
  const aboutRef = useRef(null);
  const testimonialsRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (sectionRef) => {
    sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Circles height="80" width="80" color="#A8D34B" ariaLabel="loading" visible={true} />
      </div>
    );
  }

  return (
    <div>
      <Helmet>
        <title>Home | Mwende Kivale</title>
        <meta name="description" content="Confessions of a Nutrition Freak is a platform that provides nutrition and wellness coaching services to help you achieve your health goals." />
        <meta name="keywords" content="nutrition, wellness, health, fitness, lifestyle, coaching, nutritionist, wellness coach, health coach" />
        <meta name="google-adsense-account" content="ca-pub-8626961699894922" />

      </Helmet>
      <Swiper
        spaceBetween={30}
        speed={2000}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        modules={[Autoplay, EffectFade]}
        className="mySwiper"
      >
        {slidesData.map(({ backgroundImage, title, description }, index) => (
          <SwiperSlide key={index}>
            <div
              className="relative bg-cover bg-center h-screen"
              style={{ backgroundImage: `url(${backgroundImage})` }}
            >
              <div className="absolute inset-0 bg-overlay"></div>
              <div className="relative max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
                <h2 className="text-4xl md:text-5xl font-extrabold text-secondary mb-4 animate-fade-in-down font-poppins">
                  {title}
                </h2>
                <p className="text-white text-2xl font-semibold animate-fade-in-up font-poppins">
                  {description}
                </p>
                <div className="mt-8">
                  <Link to="https://calendly.com/mwendekivale">
                    <button className="bg-secondary border-2 border-secondary px-6 py-3 rounded-lg font-bold text-white transition-all duration-300 transform hover:bg-white hover:text-secondary hover:shadow-lg animate-bounce">
                      Book a call
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div ref={aboutRef}><About /></div>
      <Choose />
      <div ref={testimonialsRef}><Testimonials /></div>
      <div ref={contactRef}><Contact /></div>
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8626961699894922"
        data-ad-slot="8626961699894922"
        data-ad-format="auto"></ins>
    </div>
  );
};

export default Home;
